import { CommonModule } from '@angular/common';
import { Component, EventEmitter, input, Output } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar-toggle-button',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatListModule, TranslateModule],
  templateUrl: './sidebar-toggle-button.component.html',
  styleUrls: ['./sidebar-toggle-button.component.scss'],
})
export class SidebarToggleButtonComponent {
  isExpanded = input<boolean>(false);
  @Output() toggle = new EventEmitter<void>();

  onClick(): void {
    this.toggle.emit();
  }
}
